class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems =
        this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') ||
      document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, CART_ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

    var that = this;
    window.addEventListener("abra:cart:changed", function() {
      setTimeout(function() {
        that.onCartUpdate();
      }), 500;
    });
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === 'cart-items') {
          return;
        }
        this.onCartUpdate();
      },
    );
    if (Shopify.currency.active != 'USD') {
      this.convertCurrencyInCart();
    }
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    if (input) {
      input.value = input.getAttribute('value');
      this.isEnterPressed = false;
    }
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace(
        '[min]',
        event.target.dataset.min,
      );
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace(
        '[max]',
        event.target.max,
      );
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace(
        '[step]',
        event.target.step,
      );
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId,
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    // console.log("UPDATRIENG")
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            'text/html',
          );
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
              this.updateHeightCartItems();
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            'text/html',
          );
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
    window.dispatchEvent(new CustomEvent('abra:render'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  convertCurrencyInCart() {
    const rate = Shopify.currency.rate;
    const currency = Shopify.currency.active;
    const freeShippingProgress = document.querySelector(".free-shipping-progress__progress-bar");
    if(freeShippingProgress != null){
      const freeShippingProgressMax = parseFloat(freeShippingProgress.getAttribute("data-max"));
      const freeShippingValue = parseFloat(freeShippingProgress.getAttribute("data-free-shipping-value"));
      const freeShippingProgressValue = parseFloat(freeShippingProgress.getAttribute("data-value"));
    
      if (freeShippingProgressMax && freeShippingValue) {
        const newMax = (freeShippingProgressMax * rate).toFixed(2);
        freeShippingProgress.setAttribute("data-max", newMax);
        const newFreeShippingValue = (freeShippingValue * rate).toFixed(2);
        freeShippingProgress.setAttribute("data-free-shipping-value", newFreeShippingValue);
        const newPercentage = ((freeShippingProgressValue / newFreeShippingValue) * 100).toFixed(2);
        freeShippingProgress.style.setProperty("--percentage", `${newPercentage}%`);
        const freeShippingAlert = document.querySelector(".free-shipping-alert");
        const freeshippingMsg = document.querySelector(".freeshipping-msg");
        const freeshippingRemainingMsg = document.querySelector(".freshipping-remainig-msg");
        const freeshippingSuccess = document.querySelector(".freeshipping-sucess");
        const cartDrawer = document.querySelector("cart-drawer");
    
        const formattedFreeShippingValue = new Intl.NumberFormat('de-DE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(newFreeShippingValue);
    
        freeshippingMsg.textContent = `Get Free Shipping by spending $${formattedFreeShippingValue} ${currency}`;
    
        if (freeShippingProgressValue >= newFreeShippingValue) {
          freeShippingAlert.classList.add("hidden");
          freeshippingMsg.classList.add("hidden");
          freeshippingRemainingMsg.classList.add("hidden");
          freeshippingSuccess.classList.remove("hidden");
          cartDrawer.classList.add("free-shipping-available");
        } else {
          freeShippingAlert.classList.remove("hidden");
          freeshippingMsg.classList.toggle("hidden", freeShippingProgressValue !== 0);
          freeshippingRemainingMsg.classList.toggle("hidden", freeShippingProgressValue === 0);
          freeshippingSuccess.classList.add("hidden");
          cartDrawer.classList.remove("free-shipping-available");
    
          const remainingAmount = (newFreeShippingValue - freeShippingProgressValue).toFixed(2);
          const formattedRemainingAmount = new Intl.NumberFormat('de-DE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(remainingAmount);
    
          freeshippingRemainingMsg.textContent = `You're $${formattedRemainingAmount} ${currency} away from Free Shipping`;
        }
    
      } 
    
      const elementsToConvert = document.querySelectorAll(".currency-convert");
      elementsToConvert.forEach(element => {
        if (element.hasAttribute('data-converted')) {
          return;
        }
    
        const freeShippingValue = parseFloat(freeShippingProgress.getAttribute("data-free-shipping-value"));
        const currentProgressValue = parseFloat(freeShippingProgress.getAttribute("data-value"));
        const remainingAmount = (freeShippingValue - currentProgressValue).toFixed(2);
    
        if (element.classList.contains("freeshipping-msg")) {
          element.textContent = `Get Free Shipping by spending $${formattedFreeShippingValue} ${currency}`;
        } else if (element.classList.contains("freshipping-remainig-msg")) {
          const formattedRemainingAmount = new Intl.NumberFormat('de-DE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(remainingAmount);
    
          element.textContent = `You're $${formattedRemainingAmount} ${currency} away from Free Shipping`;
        }
    
        element.setAttribute('data-converted', 'true');
      });
    }
  }
  
  
  
  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{body}})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter)
          cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            'is-empty',
            parsedState.item_count === 0,
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector,
          );
          this.updateHeightCartItems();
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = '';
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              '[quantity]',
              updatedValue,
            );
          }
        }
        this.updateLiveRegions(line, message);
        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`),
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector('.cart-item__name'),
          );
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-items',
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .catch((error) => {
        console.log('error', error);
        this.querySelectorAll('.loading__spinner').forEach((overlay) =>
          overlay.classList.add('hidden'),
        );
        const errors =
          document.getElementById('cart-errors') ||
          document.getElementById('CartDrawer-CartErrors');
        //errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
      window.dispatchEvent(new CustomEvent('abra:render'));
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector('.cart-item__error-text').textContent =
        message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') ||
      document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById('main-cart-items') ||
      document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`,
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`,
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove('hidden'),
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById('main-cart-items') ||
      document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`,
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`,
    );

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add('hidden'),
    );
  }

  updateHeightCartItems() {
    const cartDrawers = document.querySelectorAll('cart-drawer');
    cartDrawers.forEach((cartDrawer) => {
      const cartItems = cartDrawer.querySelector('cart-drawer-items.has-protection-product-wrapper .cart-wrapper');
      const cartFooter = cartDrawer.querySelector('cart-drawer-items > .drawer__footer');
      const cartDrawerItem =  cartDrawer.querySelector('cart-drawer-items');
      if (cartFooter) {
        const isIOS = this.checkiOS();
        let cartFooterHeight = cartFooter.offsetHeight - 20;
        let cartDrawerItemHeight = 70;
        if (window.screen.width > 767) {
            cartDrawerItemHeight = 70;
          } else {
            cartDrawerItemHeight = 180;
          }
        if (!isIOS) {
          if (window.screen.width > 767) {
            cartDrawerItemHeight = 70;
            cartFooterHeight = cartFooter.offsetHeight;
          } else {
            cartDrawerItemHeight = 180;
            cartFooterHeight = cartFooter.offsetHeight - 110;
          }
        }
        if (cartItems) {
          cartItems.style.maxHeight = `calc(100% - ${cartFooterHeight}px)`;
        }
        if (cartDrawerItem) {
          cartDrawerItem.style.height = `calc(100vh - ${cartDrawerItemHeight}px)`;
        }
      }
    })
  }

  checkiOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({note: event.target.value});
            fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{body}});
          }, CART_ON_CHANGE_DEBOUNCE_TIMER),
        );
      }
    },
  );
}
